(function () {
  'use strict';

  if (window.__radianMarqueeScrollInitialized) return;
  window.__radianMarqueeScrollInitialized = true;

  var SELECTOR = '.marquee-strip[data-scroll-parallax="true"]';
  var SCROLL_MULTIPLIER = 0.8;
  var AUTO_RESUME_DELAY = 140;
  var controllers = new WeakMap();
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function modulo(value, divisor) {
    if (!divisor) return 0;
    return ((value % divisor) + divisor) % divisor;
  }

  function MarqueeScrollController(root) {
    this.root = root;
    this.track = root.querySelector('.marquee-track');
    this.loopWidth = 0;
    this.phase = 0;
    this.visible = false;
    this.raf = 0;
    this.lastFrameTime = 0;
    this.lastScrollTime = -Infinity;
    this.lastScrollY = window.scrollY;
    this.direction = root.dataset.direction === 'left_to_right' ? 1 : -1;
    this.duration = Math.max(parseFloat(getComputedStyle(root).getPropertyValue('--marquee-speed')) || 20, 1) * 1000;

    this.onScroll = this.onScroll.bind(this);
    this.onFrame = this.onFrame.bind(this);
    this.onIntersection = this.onIntersection.bind(this);
    this.measure = this.measure.bind(this);

    if (!this.track) return;

    this.measure();
    this.root.classList.add('is-scroll-parallax-ready');
    window.addEventListener('scroll', this.onScroll, { passive: true });

    this.resizeObserver = new ResizeObserver(this.measure);
    this.resizeObserver.observe(this.track);

    this.intersectionObserver = new IntersectionObserver(this.onIntersection, {
      rootMargin: '15% 0px'
    });
    this.intersectionObserver.observe(this.root);
  }

  MarqueeScrollController.prototype.measure = function () {
    if (!this.track) return;

    var previousWidth = this.loopWidth;
    var nextWidth = this.track.scrollWidth / 2;
    if (!nextWidth) return;

    if (previousWidth) {
      this.phase = modulo(this.phase, previousWidth) / previousWidth * nextWidth;
    }

    this.loopWidth = nextWidth;
    this.render();
  };

  MarqueeScrollController.prototype.render = function () {
    if (!this.loopWidth) return;

    this.phase = modulo(this.phase, this.loopWidth);
    var offset = this.phase === 0 ? 0 : this.phase - this.loopWidth;
    this.root.style.setProperty('--marquee-scroll-offset', offset + 'px');
  };

  MarqueeScrollController.prototype.onScroll = function () {
    // Off-screen strips skip the scroll read entirely; onIntersection re-syncs lastScrollY on entry.
    if (!this.visible || reducedMotion.matches || !this.loopWidth) return;

    var scrollY = window.scrollY;
    var delta = scrollY - this.lastScrollY;
    this.lastScrollY = scrollY;

    if (!delta) return;

    this.phase += delta * SCROLL_MULTIPLIER * this.direction;
    this.lastScrollTime = performance.now();
    this.render();
  };

  MarqueeScrollController.prototype.onIntersection = function (entries) {
    this.visible = entries[0].isIntersecting;
    this.lastScrollY = window.scrollY;

    if (this.visible) {
      this.start();
    } else {
      this.stop();
    }
  };

  MarqueeScrollController.prototype.isAutoPaused = function () {
    return this.root.classList.contains('marquee-strip--pause-on-hover') && this.root.matches(':hover')
      || this.root.contains(document.activeElement);
  };

  MarqueeScrollController.prototype.onFrame = function (time) {
    if (!this.visible) {
      this.raf = 0;
      return;
    }

    var elapsed = this.lastFrameTime ? Math.min(time - this.lastFrameTime, 64) : 0;
    this.lastFrameTime = time;

    if (
      !reducedMotion.matches
      && time - this.lastScrollTime > AUTO_RESUME_DELAY
      && !this.isAutoPaused()
      && this.loopWidth
    ) {
      this.phase += this.direction * this.loopWidth / this.duration * elapsed;
      this.render();
    }

    this.raf = requestAnimationFrame(this.onFrame);
  };

  MarqueeScrollController.prototype.start = function () {
    if (this.raf || reducedMotion.matches) return;
    this.lastFrameTime = 0;
    this.raf = requestAnimationFrame(this.onFrame);
  };

  MarqueeScrollController.prototype.stop = function () {
    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = 0;
    this.lastFrameTime = 0;
  };

  MarqueeScrollController.prototype.destroy = function () {
    this.stop();
    window.removeEventListener('scroll', this.onScroll);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.intersectionObserver) this.intersectionObserver.disconnect();
    this.root.classList.remove('is-scroll-parallax-ready');
    this.root.style.removeProperty('--marquee-scroll-offset');
    controllers.delete(this.root);
  };

  function init(scope) {
    var roots = [];
    if (scope.matches && scope.matches(SELECTOR)) roots.push(scope);
    if (scope.querySelectorAll) roots = roots.concat(Array.from(scope.querySelectorAll(SELECTOR)));

    roots.forEach(function (root) {
      if (controllers.has(root)) return;
      controllers.set(root, new MarqueeScrollController(root));
    });
  }

  function destroy(scope) {
    var roots = [];
    if (scope.matches && scope.matches(SELECTOR)) roots.push(scope);
    if (scope.querySelectorAll) roots = roots.concat(Array.from(scope.querySelectorAll(SELECTOR)));

    roots.forEach(function (root) {
      var controller = controllers.get(root);
      if (controller) controller.destroy();
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });
})();
